/**
 *
 * @param {number} carbo
 * @param {number} fiber
 * @returns {string}
 */
export const wwCalculation = (carbo, fiber) => {
    const ww = ((carbo - fiber) / 10);

    return (ww < 0 ? 0 : ww).toFixed(3);
};

/**
 *
 * @param {number} protein
 * @param {number} fats
 * @returns {string}
 */
export const wbtCalculation = (protein, fats) => {
    const wbt = ((protein * 4) + (fats * 9)) / 100;

    return (wbt < 0 ? 0 : wbt).toFixed(3);
};

/**
 *
 * @param {number} carbo
 * @param {number} fiber
 * @param {number} gi
 * @returns {string}
 */
export const glCalculation = (carbo, fiber, gi) => {
    const gl = ((carbo - fiber) * gi) / 100;

    return (gl < 0 ? 0 : gl).toFixed(3);
};
